/* eslint-disable react/prop-types */
// Removed: /* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
export default function data(topSellingProducts = []) {
  // إذا تم إرسال منتجات، قم بإرجاع أعمدة وصفوف مخصصة للمنتجات
  if (topSellingProducts.length > 0) {
    return {
      columns: [
        { Header: "الصورة", accessor: "image", align: "center" },
        { Header: "اسم المنتج", accessor: "name", align: "center" },
        { Header: "السعر", accessor: "price", align: "center" },
        { Header: "عدد الطلبات", accessor: "orders_count", align: "center" },
        { Header: "اجمالي المبيعات", accessor: "product_sales_total", align: "center" },
        { Header: "الكمية المتبقية", accessor: "quantity", align: "center" }, // تم استبداله بـ orders_count
      ],
      rows: topSellingProducts.map((product) => ({
        image: (
          <MDAvatar
            src={
              product.medias && product.medias.length > 0
                ? product.medias[0].file_name
                : "https://via.placeholder.com/80"
            }
            alt={product.name}
            size="sm"
            variant="rounded"
          />
        ),
        name: (
          <MDTypography
            variant="button"
            sx={{
              maxWidth: 180,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "block",
            }}
            title={product.name}
          >
            {product.name}
          </MDTypography>
        ),
        price: `${product.price} ريال`,
        orders_count: product.order_items_count,
        product_sales_total: `${product.product_sales_total} ريال`, // Assuming this is the total sales amount
        quantity: product.quantity, // Assuming this is the remaining quantity
      })),
    };
  }
}
